module.exports = __webpack_public_path__ + "fonts/iconfont.a0239a9e.woff2";